import { axiosInstance } from '~/src/config/config_axios'
import { makeQueryUrl } from '~/src/libs'
import { convertUser } from '~/src/repositories/User/helpers/ConvertUser'
import { bodyUser, IGetUserParams, IGetUserResponse } from '~/src/repositories/User/models/User'
import { convertQuotation } from './helpers/ConvertQuotation'

export class UserRepository {
  async getUser(_param?: IGetUserParams): Promise<IGetUserResponse> {
    const data = await axiosInstance.get(makeQueryUrl(`/users`, _param))
    return convertUser(data.data)
  }

  async getUsersCsv(params?: IGetUserParams): Promise<any> {
    return await axiosInstance.get(makeQueryUrl('/users/csv', params))
  }
  
  async getQuotatoins(id: string): Promise<void> {
    const data = await axiosInstance.get(`/users/${id}/quotations`)
    return convertQuotation(data.data)
  }

  async patch(userId: number, body: bodyUser): Promise<void> {
    return await axiosInstance.patch(`/users/${userId}`, body)
  }

  async delete(userId: number): Promise<void> {
    return await axiosInstance.delete(`/users/${userId}`)
  }
}
